import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import usePageTitle from '../helpers/usePageTitle';
import { getUserOrganizations } from '../services/apiService';
import Loading from '../components/shared/LoadingOverlay';
import { useModal } from '../components/modal/ModalContext';
import CreateOrganization from '../components/organizations/CreateOrganization';
import OrganizationDetails from '../components/organizations/OrganizationDetails';

const Organizations = () => {
  const { t } = useTranslation();

  usePageTitle("organizations");

  const { showModal, hideModal } = useModal();

  const OpenCreateOrganization = () => {
    showModal(
      'createOrganizationTitle',
      <CreateOrganization hideModal={hideModal} refreshOrganizations={getOrganizations} />
    );
  };

  const openDetails = (org) => {
    showModal(
        org.name,
        <OrganizationDetails id={org.id} />
    );
  };

  const [organizations, setOrganizations] = useState(null);
  const [isLoading, setIsLoading] = useState(()=>true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);

  
  const getOrganizations = () => {
    getUserOrganizations(filters, {page: page, limit: limit}, setIsLoading, setOrganizations, setError);
  }
  
  useEffect(()=>{
    getOrganizations();
  },[page,limit,filters])

  if(isLoading) {
    return (
      <>
        <Loading />
      </>
    )
  }

  const orgList = Array.isArray(organizations) ? organizations : (organizations?.data || []);

    return (
      <div className='py-[40px]'>
        <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold">{t('organizations')}</h1>
            <div className='text-[15px] bg-blue-600 text-white font-bold px-[15px] rounded-[8px] inline-block leading-[35px] select-none cursor-pointer' onClick={OpenCreateOrganization}>{t('create_organization')}</div>
        </div>

        {orgList.length > 0 ? (
            <div className="grid grid-cols-1 gap-4">
                {orgList.map((org) => (
                    <div key={org.id} className="w-full bg-white rounded-lg shadow-sm p-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 cursor-pointer hover:bg-gray-50 transition-colors" onClick={() => openDetails(org)}>
                        <div>
                            <h3 className="text-xl font-bold mb-1">{org.name}</h3>
                            <p className="text-gray-500 text-sm">{new Date(org.joinedAt).toLocaleDateString()}</p>
                        </div>
                        <div className="flex gap-8 w-full md:w-auto justify-between md:justify-end">
                            <div className="text-center">
                                <span className="block font-bold text-lg text-gray-700">{org.memberCount}</span>
                                <span className="text-gray-500 text-xs uppercase">{t('members')}</span>
                            </div>
                            <div className="text-center">
                                <span className="block font-bold text-lg text-gray-700">{org.campaignCount}</span>
                                <span className="text-gray-500 text-xs uppercase">{t('campaigns')}</span>
                            </div>
                            <div className="text-center">
                                <span className="block font-bold text-lg text-gray-700">{org.leadCount}</span>
                                <span className="text-gray-500 text-xs uppercase">{t('leads')}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        ) : (
            <div className='bg-white rounded-[5px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.03)]'>
              <div className='text-center py-[30px]'>
                <p className='text-[18px]'>{t('no_organizations')}</p>
              </div>
            </div>
        )}
      </div>
    )

};

export default Organizations;
